/* eslint-disable react/prop-types */
import React from 'react'

/** Contexts */
import MenuContext from '@contexts/MenuContext'
import NavigationContext from '@contexts/NavigationContext'
import ThemeProvider from '@contexts/ThemeProvider';

export function onPreRenderHTML({ getHeadComponents, replaceHeadComponents }) {
  const headComponents = getHeadComponents();
  headComponents.push(<meta content="telephone=no" key="telephone" name="format-detection" />);
  replaceHeadComponents(headComponents);
}

export function wrapPageElement({ element, props: { location, } }) {
  return (
    <NavigationContext {...location}>
      {element}
    </NavigationContext>
  )
}

export function wrapRootElement({ element }) {
  return (
    <ThemeProvider>
      <MenuContext>
        {element}
      </MenuContext>
    </ThemeProvider>
  )
}